var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PdfViewer',{ref:"pdfViewer",attrs:{"source":_vm.base64Pdf}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }